import { memo } from 'react';
import { ClassTile } from './ClassTile';

const ClassTilePlaceholderComponent = () => (
    <ClassTile classId={undefined} linkTo="" openInNewTab={false} />
);

export const ClassTilePlaceholder = memo(ClassTilePlaceholderComponent);
